import type { BackendRouteDefinition } from '../types';

// Flipped from `transport: 'callable'` to `transport: 'api'` by S3-WB1
// (PRA-789). Now served by `api-core-node` at
// `POST /api/firms/arag/sessions`. The Firebase callable `signIntoArag`
// continues to exist in `cloudFunctions/` so that any deployed app version
// still holding the old route table can fall back to it; retirement of the
// callable export is deferred to S9-WB2.

export const signIntoAragRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/arag/sessions',
} as const satisfies BackendRouteDefinition;
